import { render, staticRenderFns } from "./ZettaKit.vue?vue&type=template&id=1af9f5c7"
import script from "./ZettaKit.vue?vue&type=script&lang=js"
export * from "./ZettaKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports